<template>
  <div
    class="col-100 recherche-avancee-grid recherche-avancee-substances-identite"
  >
    <div class="identite-nom-produit">
      <label for="identite-nom-produit" class="label-bold"> Nom substance </label>
      <input
        type="text"
        id="identite-nom-produit"
        :value="name"
        @input="$emit('update:name', $event.target.value)"
      />
    </div>

    <div class="identite-type">
      <label for="identite-type" class="label-bold"> Type </label>
      <select
        name="identite-type"
        id="identite-type"
        :value="types_select"
        @change="$emit('update:types_select', $event.target.value)"
      >
        <option value=""></option>
        <option v-for="type in types" :key="type">
          {{ type }}
        </option>
      </select>
    </div>

    <div class="identite-biocide">
      <label for="identite-biocide" class="label-bold"> Type de biocide </label>
      <select
        name="identite-biocide"
        id="identite-biocide"
        :value="subtypes_select"
        @change="$emit('update:subtypes_select', $event.target.value)"
      >
        <option value=""></option>
        <option v-for="subtype in subtypes" :key="subtype">
          {{ subtype }}
        </option>
      </select>
    </div>

    <div class="identite-cas">
      <label for="identite-cas" class="label-bold"> Numéro CAS </label>
      <input
        type="text"
        id="identite-cas"
        :value="cas_number"
        @input="$emit('update:cas_number', $event.target.value)"
      />
    </div>

    <div class="identite-activite">
      <label for="identite-activite" class="label-bold"> Activité </label>
      <select
        name="identite-activite"
        id="identite-activite"
        :value="principal_activity"
        @change="$emit('update:principal_activity', $event.target.value)"
      >
        <option value=""></option>
        <option v-for="principal_activity in activities" :key="principal_activity">
          {{ principal_activity }}
        </option>
      </select>
    </div>

    <div class="identite-famille">
      <label for="identite-famille" class="label-bold">
        Famille chimique
      </label>
      <select
        name="identite-famille"
        id="identite-famille"
        :value="family"
        @change="$emit('update:family', $event.target.value)"
      >
        <option value=""></option>
        <option v-for="family in families" :key="family">
          {{ family }}
        </option>
      </select>
    </div>

    <div class="identite-date-expiration">
      <label for="identite-date-expiration" class="label-bold">
        Date d'expiration
      </label>
      <div class="double-input-row">
        <sign-choice-select :value="inscription_date_expirationOperator" :required="Boolean(inscription_date_expiration)" @update="$emit('update:inscription_date_expirationOperator', $event)" ></sign-choice-select>
        <input
          type="date"
          id="identite-date-expiration"
          :value="inscription_date_expiration"
          @input="
            $emit('update:inscription_date_expiration', $event.target.value)
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import SignChoiceSelect from '@/components/SignChoiceSelect.vue'
export default {
  name: 'IdentityForm',
  components: {
    SignChoiceSelect
  },
  props: {
    name: String,
    cas_number: String,
    types_select: String,
    subtypes_select: String,
    principal_activity: String,
    family: String,
    inscription_date_start: String,
    inscription_date_expiration: String,
    

    types: Array,
    subtypes: Array,
    families: Array,
    activities: Array,
    inscription_date_expirationOperator: String
  }
}
</script>
